<template>
  <div class="toolbar-item">
    <span class="demonstration">{{ label }}</span>
    <el-select
      v-model="orderType"
      :placeholder="`请选择${label}`"
      clearable
      @change="changeSelect"
      @clear="clear"
      class="normal"
      style="width: 226px"
    >
      <el-option v-for="(item, idx) in getListOptions" :label="item.name" :value="item.value" :key="idx"> </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '运单类型'
    },
    serachType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      orderTypeList: [
        { name: '普通运单', value: 1 },
        { name: '撮合运单', value: 2 }
      ],
      stockList: [
        { name: '普通货源', value: 1 },
        { name: '撮合货源', value: 2 }
      ],
      orderType: ''
    };
  },
  computed: {
    getListOptions() {
      if (this.serachType == 1) {
        return this.orderTypeList;
      }
      if (this.serachType == 2) {
        return this.stockList;
      }
      return [];
    }
  },

  methods: {
    changeSelect(val) {
      this.$emit('changeValue', val);
    },
    clear() {
      this.$emit('changeValue', null);
    },
    resetData() {
      this.orderType = null;
      this.$emit('changeValue', null);
    }
  }
};
</script>
